import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";

const AdminProtected = ({ children }) => {
  const { token, admin, checking } = useAdminAuth();
  const location = useLocation();

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0E0E0E] text-white">
        <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37]">Loading…</p>
      </div>
    );
  }
  if (!token || !admin) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }
  return children;
};

export default AdminProtected;
